import styled from 'styled-components';

import { space } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';

const Selector = styled.ul`
  align-items: center;
  border-left: 1px solid ${colors.neutral[800]};
  display: inline-flex;
  margin: 0 0 0 ${space(2)};
  flex-wrap: nowrap; // Mantiene todos los idiomas en una sola línea
  max-width: 100%; // Evita que el selector se desborde del contenedor padre

  li {
    flex-shrink: 0; // Evita que los elementos de la lista se compriman
    white-space: nowrap; // Asegura que cada idioma se mantenga en una línea
  }

  .language {
    color: ${colors.neutral[400]};
    font-weight: 400;
    margin: 0 ${space()} 0 ${space(2)};
    text-decoration: none;
    white-space: nowrap; // Evita que las palabras se corten en medio
    display: inline-block; // Asegura que cada enlace mantenga su espacio

    &:hover {
      color: ${colors.primary[600]};
    }
  }

  .active {
    color: ${colors.primary[600]};
  }

  @media (max-width: 767px) {
    flex-wrap: wrap; // Fuerza el wrap en móvil para que los idiomas se muestren en múltiples líneas
    justify-content: center; // Centra los idiomas horizontalmente
    width: 100%; // Asegura que ocupe todo el ancho disponible
    margin: ${space(2)} 0 0 0; // Ajusta el margen para móvil
    border-left: none; // Elimina el borde izquierdo en móvil
    border-top: 1px solid ${colors.neutral[800]}; // Añade borde superior para separación visual
    padding-top: ${space(2)}; // Añade padding superior para el nuevo borde

    .language {
      margin: ${space(1)} ${space(1)} 0 0; // Ajusta los márgenes para mejor espaciado en múltiples líneas
    }
  }
`;

export { Selector };
